import { Entity, formatTicker } from '@api';
import { Icon } from '@design/components/icon/Icon';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { TruncateTooltip } from '@terminal/components/truncate-tooltip/TruncateTooltip';
import { MAX_TICKER_DISPLAY_LENGTH } from '@terminal/stores/use-watchlist/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CompanyNameCell.module.scss';

export const CompanyNameCell = ({
  entity,
  showAlertIcon = false,
}: {
  entity: Entity;
  showAlertIcon?: boolean;
}) => {
  const { t } = useTranslation('common');

  if (!entity.id) {
    return (
      <span
        className={styles.styledTextNa}
        data-testid="table-cell-empty-value"
      >
        {t('common:table.na')}
      </span>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.flexRowWrapper}>
        <div className={styles.iconsContainer}>
          <AssetLogoContainer entity={entity} size={32} />
          {showAlertIcon && (
            <div className={styles.iconContainer}>
              <Icon
                className={styles.styledIcon}
                iconName="ExclamationCircle"
                fillColor="var(--icon-critical)"
                strokeColor="var(--background-soft)"
                size={16}
              />
            </div>
          )}
        </div>
        <div className={styles.companyNameContainer}>
          <TruncateTooltip
            text={entity.name}
            atLength={MAX_TICKER_DISPLAY_LENGTH}
          />
          <p className={styles.tag}>{formatTicker(entity)}</p>
        </div>
      </div>
    </div>
  );
};
